<template>
  <div class="my-20 relative">
    <CardSlider :breakpoints="breakpoints" :heading="heading">
      <LinkField
        v-for="{ cta, image, alt, id } in sports"
        :key="id"
        v-bind="cta"
        class="lg:px-6 px-4 group flex flex-col items-center"
      >
        <FixedAspect :ratio="1.0" class="w-full h-full">
          <CldnImg
            v-if="image[0]"
            :src="image[0].url"
            width="384"
            :ratio="1"
            crop="fill"
            :alt="alt ? alt : image[0].title"
            class="group-hover:shadow-xl transition-shadow rounded-full"
          />
        </FixedAspect>
        <div class="mt-4 fluid-base leading-relaxed font-light font-medium uppercase">
          {{ cta.text }}
        </div>
      </LinkField>
    </CardSlider>
  </div>
</template>
<script>
import gql from 'graphql-tag';
import CldnImg from '@/components/CldnImg';
import FixedAspect from '@/components/common/FixedAspect';
import LinkField from '@/components/common/LinkField';
import CardSlider from '@/components/common/CardSlider';


export default {
  components: {
    CardSlider,
    FixedAspect,
    CldnImg,
    LinkField,
  },
  props: {
    heading: {
      type: String,
      default: '',
    },
    sports: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      breakpoints: [
        {
          minWindowWidth: 0,
          slidesToShow: 2,
          slidesToScroll: 2,
        },
        {
          minWindowWidth: 768,
          slidesToShow: 5,
          slidesToScroll: 5,
        },
      ],
    };
  },
};
</script>
